import React from "react";
import { Provider } from "react-redux";
import { PropTypes } from "prop-types";
import { BorrowerRegistrationComponent } from "./BorrowerRegistrationComponent";
import ChatWidget from "../../shared_modules/five9-chat-widget";

const BorrowerRegistrationClient = ({ store, config }) => {
  const { chatFive9Context } = store.getState();
  return (
    <Provider store={store}>
      <BorrowerRegistrationComponent config={config} />
      {chatFive9Context?.isFiveChatEnabled && (
        <ChatWidget chatFive9Context={chatFive9Context} />
      )}
    </Provider>
  );
};

BorrowerRegistrationClient.propTypes = {
  store: PropTypes.object.isRequired,
  config: PropTypes.object,
};

export default BorrowerRegistrationClient;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');